<panel>
  <h1>{{ 'sale.orders-with-warnings' | translate }}</h1>
  <section>
    <custom-select [label]="'list-orders.filter-sales-team' | translate"
      [selectList]="salesTeamList"
      [(value)]="selectedTeamId"
      [autoSort]="true"
    [required]="true"></custom-select>
  </section>
  @if (selectedTeamId) {
    <list-orders
      statusFilter="warning"
      [salesTeamsIds]="[selectedTeamId]"
      [groupBy]="getSalesTeam"
      [subGroupBy]="getSellerName"
      [showSellerName]="false"
    [disabled]="warningWasClosed"></list-orders>
  }
</panel>
